import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { getInventoryListApi, deleteAssetDetailRow, EditTaskFormApi, fillEditFromApi, UpdateTaskFormApi, uploadFileApi, importFileApi, exportAssetDetailListApi, DownloadAllApi, exportMasterApi,bulkDelete,onArchiveAsset} from "../apiServices";
import { Box, Button, Grid, IconButton } from "@material-ui/core";
import InventorySearchBar from "../components/InventorySearchBar";
import InventoryTable from "../components/InventoryTable";
import { convertFilterObject, removeEmptyKey, permissionCheckFnforCamo} from "../../../../utils";
import { inventoryTableHead } from "./InventoryTaskHead";
import { EmptyCollection, PageLoader, AccessDenied, DeletePopUp} from "../../../../shared_elements";
import InventoryList from "../components/InventoryList";
import BasicDetailHeader from "../../BasicDetailHeader";
import { trackActivity } from "../../../../utils/mixpanel";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
class MainInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addFormDialog: false,
            sidebarOpen: true,
            tabIndex: 0,
            pageLoader: false,
            sort: "",
            sort_by: "",
            assetsDetail: {
                list: [],
                pagination: {},
                asset_count: {},
                new_task_last_used_folder_uuid: '',
                last_used_folder_uuid_link_document: "",
                checkbox_last_used_folder_uuid: "",
                checkbox_last_used_folder_name: ""
            },
            headerTsn: "",
            headerCsn: "",
            date_of_manufacture: "",
            currentRecordPerPage: 250,
            uuid: "",
            slug:'',
            basicDetails:{},
            isBasicDetailExpanded: true,
            bulkOperation: { modal: false, ids: [], title: '', type: '' },
            archiveModal:false
        };
        this.getInventoryListApi = getInventoryListApi.bind(this);
        this.openAddForm = this.openAddForm.bind(this);
        this.closeAddForm = this.closeAddForm.bind(this);
        this.toggleSidebar = this.toggleSidebar.bind(this);
        this.handleDeleteRow = deleteAssetDetailRow.bind(this);
        this.handleEditRow = fillEditFromApi.bind(this);
        this.UpdateTaskFormApi = UpdateTaskFormApi.bind(this);
        this.uploadFileApi = uploadFileApi.bind(this);
        this.importFileApi = importFileApi.bind(this);
        this.downloadAllApi = DownloadAllApi.bind(this);
        this.exportAssetDetailListApi = exportAssetDetailListApi.bind(this);
        this.exportMasterApi = exportMasterApi.bind(this);
        this.bulkDelete = bulkDelete.bind(this);
        this.onArchiveAsset = onArchiveAsset.bind(this);
        
    }

    componentDidMount() {
        this.getData();
        this.pullData();
        trackActivity('Inventory  Page Visited - CAMO', {
            event_type: 'Page Visited',
            page_title: 'Inventory',
        })
    }

    pullData = (slug, tsn, csn, date_of_manufacture) => {
        this.setState({ slug: slug });
        this.setState({ headerTsn: tsn });
        this.setState({ headerCsn: csn });
        this.setState({ date_of_manufacture: date_of_manufacture });
    };

    uuidData = (uuid) => {
        this.setState({ uuid: uuid });
    }
    getData(item) {
        this.getInventoryListApi({ per_page: this.state.currentRecordPerPage }, "skeletonLoader", this.props, item ? item : null);
    }

    openAddForm() {
        this.setState({ addFormDialog: true });
    }
    closeAddForm() {
        this.setState({ addFormDialog: false });
    }

    toggleSidebar() {
        this.setState({ sidebarOpen: !this.state.sidebarOpen });
    }
    createSortHandler = (sortField) => {
        const { sort, sort_by, filter, tabIndex, assetsDetail } = this.state;
        this.setState({
            sort: sortField,
            sort_by: sort_by === "asc" ? "desc" : "asc",
        })
        if (sort_by === "asc") {
            this.getInventoryListApi({ ...filter, sort: sortField, sort_by: "desc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
        } else {
            this.getInventoryListApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
        }
    }
    searchResults = (item) => {
        if (item !== null) {
            this.getData(item);
        }
    };

    updateFormData = async (updateId, updatedData, props,addform,closeform) => {
        await this.UpdateTaskFormApi(updateId, updatedData, props, this.state.currentRecordPerPage,addform,closeform)
    };

    fileUploadData = async (uploadId, formdata, props, haveAttachments) => {
        await this.uploadFileApi(uploadId, formdata, props, this.state.currentRecordPerPage, haveAttachments)
    };

    importFile = (formData, props, isXLSX) => {
        this.importFileApi(formData, props, isXLSX, this.state.currentRecordPerPage)
    }

    exportAssetDetailListFunc = (props) => {
        const { basicDetails } = this.state;
        this.exportAssetDetailListApi(props, '', this.props, basicDetails);
    };

    downloadAllFilesApi = (props) => {
        this.downloadAllApi(props);
    };

    refreshComp = () => {
        this.getData();
    };
    toggleBulkOps = async (flag, type, item) => {
        const { bulkOperation, assetsDetail } = this.state;   
        try {
            if (type === 'bulk') {
                const response = await this.getInventoryListApi(
                    { per_page: flag ? assetsDetail?.pagination?.total : this.state.currentRecordPerPage},
                    "skeletonLoader",
                    this.props,
                    null
                );
                this.setState({
                    bulkOperation: { ...bulkOperation, type: 'bulk', ids: flag ? response?.data?.results : [] }
                });
            } else {
                this.setState({
                    bulkOperation: {
                        ...bulkOperation,
                        type: 'single',
                        ids: flag ? [...bulkOperation.ids, item] : bulkOperation.ids.filter(optionItem => optionItem.id !== item.id)
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    engineType=(data)=>{
		this.setState({basicDetails:data})
	}
    render() {
        const { tabIndex, applyingFilter, sort, sort_by, assetsDetail, pageLoader, date_of_manufacture, uuid,slug,bulkOperation,basicDetails,archiveModal, isBasicDetailExpanded } = this.state;
        return (
            <section className="amp-listing-section">
                {pageLoader ? <PageLoader /> : null}
                <Grid className="mt-0" spacing={3} container>
                    <Grid className="pt-0 pr-0" xs={12} item>
                        <SubDetails
                            masterExport={true}
                            title="Inventory List"
                            slug={slug}
                            module='inventory'
                            match={this.props?.match}
                            onRefresh={this.refreshComp}
                            permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
                        />
                        <BasicDetailHeader props={this.props} func={this.pullData} uuid={this.uuidData}  engineType={this.engineType} module="inventory" onAccordionChange={(expanded) => this.setState({ isBasicDetailExpanded: expanded })} />
                        {permissionCheckFnforCamo({
                            primaryKey: "ad_status",
                            keyIndex: "R",
                        }) ? (
                            <div className="custom-border">
                                <InventorySearchBar
                                    currentRecordPerPage={this.state.currentRecordPerPage}
                                    headerTsn={this.state.headerTsn}
                                    date_of_manufacture={date_of_manufacture}
                                    headerCsn={this.state.headerCsn}
                                    applyingFilter={applyingFilter}
                                    tabIndex={tabIndex}
                                    pageLoader={"pageLoader"}
                                    props={this.props}
                                    uuid={uuid}
                                    basicDetails={basicDetails}
                                    assetsDetail={assetsDetail.list}
                                    getResponseBack={this.refreshComp}
                                    importFile={this.importFile}
                                    fileUploadData={this.fileUploadData}
                                    searchData={(e) => this.searchResults(e.target.value)}
                                    exportReportFn={(file) => this.exportAssetDetailListFunc({download:file.extension,per_page:assetsDetail.pagination.per_page,page:assetsDetail.pagination.page , ...{ ...convertFilterObject(removeEmptyKey(applyingFilter)), asset_type: tabIndex, ...(sort === "" && sort_by === "" ? {} : { sort, sort_by }) }, }, "pageLoader")}
                                />
                                <InventoryTable
                                    currentRecordPerPage={this.state.currentRecordPerPage}
                                    heads={inventoryTableHead}
                                    sort={sort}
                                    sort_by={sort_by}
                                    bulkDeletefn={()=>this.bulkDelete(this.props,bulkOperation, assetsDetail.pagination.per_page,)}
                                    bulkOperation={bulkOperation}
                                    basicDetails={basicDetails}
                                    isBasicDetailExpanded={isBasicDetailExpanded}
                                    bulkFlag={assetsDetail?.list?.length === bulkOperation?.ids?.length && assetsDetail?.list?.length > 0}
                                    toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'bulk')}
                                    data={assetsDetail?.list?.map((item, index) => (
                                        <InventoryList
                                           bulkOperation={bulkOperation}
                                           toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'single', item)}
                                            currentRecordPerPage={this.state.currentRecordPerPage}
                                            key={index}
                                            item={item}
                                            index={index}
                                            uuid={uuid}
                                            basicDetails={basicDetails}
                                            assetsDetail={assetsDetail}
                                            getResponseBack={this.refreshComp}
                                            last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
                                            last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
                                            checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
                                            checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
                                            headerTsn={this.state.headerTsn}
                                            headerCsn={this.state.headerCsn}
                                            handleDeleteRow={(data) => this.handleDeleteRow(item, this.props, this.state.currentRecordPerPage)}
                                            updateFormData={this.updateFormData}
                                            handleEditRow={(data) => this.handleEditRow(item, this.props)}
                                            props={this.props}
                                            fileUploadData={this.fileUploadData}
                                            downloadAllApi={(file) => this.downloadAllFilesApi({ download: file.extension, ...{ ...convertFilterObject(removeEmptyKey(applyingFilter)), asset_type: tabIndex, item, }, }, "pageLoader")}
                                        />
                                    ))}
                                    createSortHandler={this.createSortHandler}
                                    pagination={assetsDetail.pagination}
                                    onChangePage={(event, newPage) => this.getInventoryListApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: assetsDetail.pagination.per_page, page: newPage + 1, })), }, "pageLoader", this.props)}
                                    onChangeRowsPerPage={(event) =>
                                        this.setState(
                                            { currentRecordPerPage: event.target.value },
                                            () => {
                                                this.getInventoryListApi({ ...convertFilterObject(removeEmptyKey({ ...applyingFilter, asset_type: this.state.tabIndex, per_page: this.state.currentRecordPerPage, })), }, "pageLoader", this.props);
                                            }
                                        )
                                    }
                                    noRecord={assetsDetail?.list?.length ? null : !this.state.pageLoader ? (<EmptyCollection title="No Records Found" />) : null}
                                />
                            </div>
                        ) : (
                            <AccessDenied />
                        )}
                    </Grid>
                </Grid>
                {
                    archiveModal ?
                        <DeletePopUp
                            title='Archive Asset'
                            deleteRecordFn={() => this.onArchiveAsset(this.props, slug)}
                            modal={() => this.setState({ archiveModal: true })}
                            content='Are you sure, you want to Archive?'
                            toggleModalFn={() => this.setState({ archiveModal: false })}
                            confirmText="ARCHIVE"
                        />
                        : null
                }
            </section>
        );
    }
}
export default withSnackbar(MainInventory);